import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { ratePlanCodes, networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  const videoStructuredData = createVideoStructuredData({
    networkName: 'beIN Sports',
    callsign: 'BEIN1HD',
    logoUrl: networkLogos.bein.logoUrl,
    slug: 'latino-es',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="es"
        market="latino"
        callsign="BEIN1HD"
        offerCode={ratePlanCodes.latino}
        title="Mira beIN Sports en vivo con Fubo"
        networkSet="entertainmentLatino"
        networkName="beIN Sports"
      />
    </>
  )
}
